import OrganizationsMenu from './OrganizationsMenu';

export default OrganizationsMenu;
